import React from "react";
import about from "./assets/img/about.jpg";

import './assets/css/style.css';
import './assets/vendor/aos/aos.css';
import './assets/vendor/bootstrap/css/bootstrap.min.css';
import './assets/vendor/bootstrap-icons/bootstrap-icons.css';
import './assets/vendor/boxicons/css/boxicons.min.css';
import './assets/vendor/glightbox/css/glightbox.min.css';
import './assets/vendor/swiper/swiper-bundle.min.css';

const About = () => {
    return(
<section id="about" class="about">
      <div class="container">

        <div class="row">
          <div class="col-lg-6" data-aos="">
            <img src={about} class="img-fluid" alt="" />
          </div>
          <div class="col-lg-6 d-flex flex-column justify-contents-center" data-aos="">
            <div class="content pt-4 pt-lg-0">
              <h3>About Us</h3>
              <p class="fst-italic">
              SpireWeb Technologies, based in Kolhapur since 2017, is a leading web development company. We provide clients with fully customised web development services that allow them to achieve their business objectives.
              </p>
              <ul>
                <li class="fst-italic"><i class="bi bi-check-circle"></i> Our goal is to become the premier location-based IT services provider in the world.</li>
                <li class="fst-italic"><i class="bi bi-check-circle"></i> We are passionate about helping businesses reach their business goals through innovative technologies.</li>
                <li class="fst-italic"><i class="bi bi-check-circle"></i> With our dedication to quality, you save both time and money.</li>
              </ul>
              {/* <p class="fst-italic">
              SpireWeb Technologies is a web and software development company in India providing IT Services. We always intend to provide our customers with a sustainable competitive advantage by offering cost effective solution. Since our inception, Our dedication and determination to complete each project as per client’s need has resulted in Sovereign becoming one of the most admired IT services provider. At Sovereign we are driven by our values of accountability, integrity and excellence.
              </p> */}
            </div>
          </div>
        </div>

      </div>
    </section>
    );
}


export default About;